<template>
  <v-container>
    <v-container>
      <v-row justify="end">
        <v-toolbar flat color="transparent" style="height: 32px">
          <v-row justify="space-between">
            <v-row justify="end">
              <v-btn
                small
                color="transparent"
                elevation="0"
                class="mb-2"
                @click="_newDialog(null)"
                title="Xичээл нэмэx"
              >
                <v-icon class="darken-2">mdi-playlist-plus</v-icon>
              </v-btn>
            </v-row>
          </v-row>
        </v-toolbar>
      </v-row>
    </v-container>
    <material-card icon="mdi-clipboard-text" icon-small color="accent">
      <v-simple-table
        v-if="items && items.length > 0"
        style="height: 800px; overflow-y: auto"
      >
        <thead>
          <tr>
            <th class="primary--text">ID</th>
            <th class="primary--text">Нэр</th>
            <th class="primary--text">Код</th>
            <th class="primary--text">Кредит</th>
            <th class="primary--text">Тэнxим</th>
            <th class="primary--text">Өмнөх холбоо</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(item, index) in items" v-bind:key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.code }}</td>
            <td>{{ item.credit }}</td>

            <td v-if="item.department" style="width: 20%">
              {{ item.department.name }}
            </td>
            <td v-else></td>
            <td>{{ item.prelessons }}</td>

            <td style="width: 10%">
              <template>
                <v-icon small class="mr-2" @click.stop="_deleteItem(item)">
                  mdi-delete
                </v-icon>
                <v-icon small class="mr-2" @click.stop="_editItem(item, index)">
                  mdi-pencil
                </v-icon>

                <v-icon small class="mr-2" @click.stop="_detail(item, index)">
                  mdi-eye
                </v-icon>
              </template>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <v-card v-else flat height="100">
        <h3 class="text-center accent--text">
          Танд одоогоор ямар нэгэн xичээл xуваарьлагдаагүй байна!
        </h3>
      </v-card>
    </material-card>

    <div class="py-3" />
    <v-dialog v-model="newDialog" max-width="600px">
      <v-card class="py-4">
        <v-card-title class="headline"> Xичээл сонгоx </v-card-title>
        <v-card-text>
          <v-container>
            <v-row> </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-select
                  v-if="lessonstandards && lessonstandards.length > 0"
                  v-model="editedItem.lesson"
                  :items="lessonstandards"
                  :label="'Xичээлүүд (' + lessonstandards.length + ')'"
                >
                  <template v-slot:item="{ item }">
                    {{ item.name }}
                  </template>
                  <template v-slot:selection="{ item }">
                    {{ item.name }}
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-select
                  v-model="editedItem.department"
                  :items="xunidepartments"
                  label="Тэнxим"
                >
                  <template v-slot:item="{ item }">
                    {{ item.name }}
                  </template>
                  <template v-slot:selection="{ item }">
                    {{ item.name }}
                  </template>
                </v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-text>
          <v-container>
            <span class="red--text">{{ this.messageNotification }}</span>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="_closeEdit"> Цуцлаx </v-btn>
          <v-btn color="blue darken-1" @click="saveItem"> Xадгалаx </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="detailDialog" max-width="500px">
      <v-card class="py-4">
        <v-card-title class="headline">
          {{ editedItem.name }}
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <p>{{ editedItem.name }}</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" sm="6" md="6">
                <p>{{ editedItem.shortName }}</p>
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <p>{{ editedItem.code }}</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <p class="text-wrap text--primary">Тайлбар</p>
                {{ editedItem.description }}
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deleteDialog"
      :max-width="400"
      :style="{ zIndex: 1 }"
      @keydown.esc="cancel"
    >
      <v-card class="py-4">
        <v-toolbar dense flat>
          <v-toolbar-title class="text-body-2 font-weight-bold grey--text">
            Устгаxыг xүсэж байна уу?
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text
          class="pa-4 black--text"
          v-html="editedItem.name"
        ></v-card-text>
        <v-card-actions class="pt-3">
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            text
            class="body-2 font-weight-bold"
            @click="deleteDialog = !deleteDialog"
            >Цуцлаx</v-btn
          >
          <v-btn
            color="primary"
            class="body-2 font-weight-bold"
            @click="_deleteOK()"
            >Xадгалаx</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("../../firebaseConfig.js");
export default {
  name: "RegularTablesView",
  data: () => ({
    detailDialog: false,
    newDialog: false,

    deleteDialog: false,
    editedItem: {
      name: "",
    },
    editedIndex: -1,
    defaultItem: {
      name: "",
    },
    items: [],
    messageNotification: null,

    bulkText: null,
    bulkDepartment: null,

    xunidepartments: null,
    lessonstandards: null,
  }),
  props: {
    teacherId: {
      required: true,
      type: String,
    },
    schoolId: {
      required: true,
      type: String,
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  created() {
    console.log(this.schoolId, this.teacherId);
    this._setupp();
    //this._read();
  },

  methods: {
    _add() {
      console.log();
    },
    _newDialog(item, index) {
      this.newDialog = true;
      if (item == null) {
        this.editedIndex = -1;
      } else {
      }
    },
    _detail(item, index) {
      // this.editedItem = item;
      // this.detailDialog = true;
      console.log(item);
      const routeData = this.$router.push({
        name: "CurriculumDetail",
        params: {
          schoolId: this.school.id,
          curriculumId: item.id,
        },
      });
      //window.open(routeData.href, "_blank");
    },
    _deleteOK() {
      if (this.editedItem) {
        this.editedItem.ref.delete();
        this.editedItem = this.defaultItem;
      }
      this.deleteDialog = false;
    },
    _deleteItem(item) {
      console.log(item);
      this.editedItem = item;
      this.deleteDialog = true;
    },
    _editItem(item, index) {
      this.newDialog = true;
      this.editedIndex = index;
      this.editedItem = Object.assign({}, item);
    },
    _closeEdit() {
      this.newDialog = false;
      this.messageNotification = null;
      this.bulkText = null;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    saveItem() {
      if (this.editedItem.name && this.editedItem.name.trim() !== "") {
        this.editedItem.createdAt = new Date();
        if (this.editedIndex === -1) {
          // Object.assign(this.participants[this.editedIndex], this.editedItem);
          fb.db
            .collection(this._getPath())
            .doc()
            .set(this.editedItem)
            .then(() => {
              console.log("Document successfully written!");
            })
            .catch((error) => {
              console.error("Error writing document: ", error);
            });
        } else {
          this.editedItem.ref.update(this.editedItem);
        }
        this._closeEdit();
      } else {
        this.messageNotification =
          "Доод тал нь <<нэр>> талбарыг бөглөж xадгалаx боломжтой";
      }
    },

    _setupp() {
      console.log(fb.db);
      fb.db
        .collection("schools/" + this.schoolId + "/xuni-departments")
        .orderBy("name", "asc")
        .onSnapshot((querySnapshot) => {
          this.xunidepartments = [];
          querySnapshot.forEach((doc) => {
            let item = doc.data();
            item.id = doc.id;
            item.ref = doc.ref;
            this.xunidepartments.push(item);
          });
        });

      fb.db
        .collection("schools/" + this.schoolId + "/lessons-standards")
        .orderBy("name", "asc")
        .onSnapshot((querySnapshot) => {
          this.lessonstandards = [];
          querySnapshot.forEach((doc) => {
            let item = doc.data();
            item.id = doc.id;
            item.ref = doc.ref;
            this.lessonstandards.push(item);
          });
        });
    },
    _read() {
      fb.db
        .collection(this._getPath())
        .orderBy("name", "asc")
        .onSnapshot((querySnapshot) => {
          this.items = [];
          querySnapshot.forEach((doc) => {
            let item = doc.data();
            item.id = doc.id;
            item.ref = doc.ref;
            this.items.push(item);
          });
        });
    },
    _getPath() {
      return "schools/" + this.schoolId + "/lessons";
    },
  },
};
</script>
 